export enum ColorPalette {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
